import loadable from '@wix/yoshi-flow-editor/loadable';

export const Comments = loadable(
  () => import(/* webpackChunkName: "Comments" */ './Comments'),
  {
    resolveComponent: (component) => component.Comments,
  },
);
